import React from "react";
import { DatePicker, TextInput } from "@opendate-app/setlist";

import FanFilterSelect from "./FanFilterSelect";

import { formInputContainerStyle } from "./FanFilterGroupForm";

const NUMBER_WIDTH = 120;

export const toIsoDate = (date) => {
  if (!date) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

export const fromIsoDate = (value) => {
  if (!value) return null;
  const [year, month, day] = value.split("-").map(Number);
  return new Date(year, month - 1, day);
};

const TimeframeFields = ({ params, options, onSelect, onCommitText, onDate, resetKey = "", placeholder = "Any time" }) => {
  const renderSelect = (key, values, ariaLabel, placeholder) => (
    <div style={formInputContainerStyle}>
      <FanFilterSelect
        aria-label={ariaLabel}
        placeholder={placeholder}
        options={(values || []).map((value) => ({ value, label: value }))}
        value={params[key] || null}
        onChange={(value) => onSelect(key, value)}
      />
    </div>
  );

  const renderDatePicker = (key, placeholder) => (
    <div style={formInputContainerStyle}>
      <DatePicker
        aria-label={placeholder}
        placeholder={placeholder}
        value={fromIsoDate(params[key])}
        onChange={(date) => onDate(key, toIsoDate(date))}
      />
    </div>
  );

  return (
    <>
      {renderSelect("timeframe", options.timeframe, "Select a timeframe", placeholder)}

      {params.timeframe === "In the last" && (
        <>
          <div style={{ ...formInputContainerStyle, width: NUMBER_WIDTH }}>
            <TextInput
              key={`${resetKey}-within_value`}
              aria-label="Number"
              type="number"
              min="1"
              step="1"
              placeholder="Number"
              defaultValue={params.within_value ?? ""}
              onBlur={(e) => onCommitText("within_value", e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") onCommitText("within_value", e.target.value);
              }}
            />
          </div>
          {renderSelect("within_unit", options.within_unit, "Unit", "Unit")}
        </>
      )}

      {params.timeframe === "Between" && (
        <>
          {renderDatePicker("start_date", "Start date")}
          {renderDatePicker("end_date", "End date")}
        </>
      )}
    </>
  );
};

export default TimeframeFields;
